function padTwoDigits(number: string) {
    const text = ('0' + number);
    return text.substr(text.length - 2);
}

export default function (duration: string): string | null {
    let matches = /^PT([0-9]+)M([0-9]+)S$/.exec(duration);

    if (matches) {
        return padTwoDigits(matches[1]) + ':' + padTwoDigits(matches[2]);
    }

    matches = /^PT([0-9]+)H([0-9]+)M([0-9]+)S$/.exec(duration);

    if (matches) {
        return padTwoDigits(matches[1]) + ':' + padTwoDigits(matches[2]) + ':' + padTwoDigits(matches[2]);
    }

    matches = /^P([0-9]+)DT([0-9]+)H([0-9]+)M([0-9]+)S$/.exec(duration);

    if (matches) {
        return '>24h';
    }

    return null;
}
